import React, {useCallback, useMemo, useState} from 'react';

import AppModal from '../../../common/components/CustomModal/AppModal';
import {HomeScreens} from '@buncha/home/navigation/types';
import {Modules} from '@buncha/utils/types';
import {Shift} from '../../../../src/openShifts/types/openShifts';
import TakeShiftModalBody from './TakeShiftModalBody';
import {useColorThemeType} from '../../../appStyles/hooks/theme';
import {useGetLocale} from '@buncha/localization/hooks';
import {useTakeShift} from '../../../../src/openShifts/hooks/openShifts';

interface TakeShiftModalProps {
  open: boolean;
  onClose: () => void;
  storeShift: Shift;
}

const TakeShiftModal: React.FC<TakeShiftModalProps> = props => {
  const theme = useColorThemeType('main');
  const shiftId = props?.storeShift?.shiftId || '';
  const [selectingShift, setSelectingShift] = useState(false);
  const {takeShift, loading} = useTakeShift();
  const {button} =
    useGetLocale(Modules.openShifts, HomeScreens.OpenShifts) ?? {};

  const getHeading = useMemo(() => {
    if (selectingShift) return button?.takeOpenShift;
    return button?.takeShift;
  }, [button?.takeOpenShift, button?.takeShift, selectingShift]);

  const getButtonText = useMemo(() => {
    if (selectingShift) return button?.takeOpenShift;
    return button?.takeShift;
  }, [button?.takeOpenShift, button?.takeShift, selectingShift]);

  const confirmTakingShift = useCallback(async () => {
    if (!selectingShift) {
      setSelectingShift(true);
      return;
    }
    if (shiftId) {
      await takeShift(shiftId);
      props?.onClose();
    }
  }, [props, selectingShift, shiftId, takeShift]);

  const cancelTakingShift = useCallback(() => {
    props.onClose();
    setSelectingShift(false);
  }, [props]);
  return (
    <AppModal
      isOpen={props?.open}
      onClose={() => props?.onClose()}
      topCTAHandelr={confirmTakingShift}
      bottomCTAHandelr={cancelTakingShift}
      title={getHeading}
      modalBody={
        <TakeShiftModalBody
          storeShift={props?.storeShift}
          selectingShift={selectingShift}
        />
      }
      ctaBottomTitle={button?.cancel}
      ctaTopTitle={getButtonText}
      topCTAColor={theme?.background.green[100]}
      loading={loading}
    />
  );
};

export default React.memo(TakeShiftModal);
